
export const environment = {
  production: false,
  baseUrl: 'http://' + window.location.hostname + ':8080/cbeManager/api/',

  // serverStatus Component
  serverPingTimeout: 10,
  serverPingInterval: 10,
  serverPingXInterval: 60,
  serverPingOnMax: 10,

  // threadStatus Component
  threadRefreshRate: 10
};

